import React, { FunctionComponent } from 'react';
import { Stack, Typography } from '@mui/material';
import moment from 'moment';

import { ITransactionLog } from '../../../../store/V2/TransactionLogsSlice';
import {
  StyledTableCell,
  StyledTableRow,
} from '../../../../components/V2/Table/type1/TableStyles';
import { getFormatedDurationByMinutes } from '../../../../helper';

interface TransactionLogTableRowProps {
  transactionLog: ITransactionLog;
}

const TransactionLogTableRow: FunctionComponent<TransactionLogTableRowProps> = ({
  transactionLog,
}) => {
  const dateMoment = moment(transactionLog.date);
  const creditChange = transactionLog.creditChange
    ? getFormatedDurationByMinutes({ minutes: transactionLog.creditChange })
    : '-';

  const balance = transactionLog.currentBalance
    ? getFormatedDurationByMinutes({ minutes: transactionLog.currentBalance })
    : '-';

  return (
    <StyledTableRow hover key={transactionLog._id}>
      <StyledTableCell>
        <Stack>
          <Typography fontSize="14px" fontWeight={500} color="#1E293B">
            {dateMoment.format('ddd MMM DD YYYY')}
          </Typography>
          <Typography fontSize="12px" color="#94A3B8">
            {dateMoment.format('hh:mm A')}
          </Typography>
        </Stack>
      </StyledTableCell>
      <StyledTableCell>
        <Typography
          fontSize="14px"
          fontWeight={500}
          color="#1E293B"
          className="ellipsis-text two-lines"
        >
          {transactionLog.description || '-'}
        </Typography>
      </StyledTableCell>
      <StyledTableCell>
        <Typography fontSize="14px" fontWeight={500} color="#1E293B">
          {creditChange}
        </Typography>
      </StyledTableCell>
      <StyledTableCell>
        <Typography fontSize="14px" fontWeight={500} color="#1E293B">
          {balance}
        </Typography>
      </StyledTableCell>
    </StyledTableRow>
  );
};

export default TransactionLogTableRow;
